import { Spin } from 'antd';
import useStockInvest from 'hook/useStockInvest';
import { param } from 'jquery';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from 'store/actionReducers/LoadingStore';
import { setFilterStockInvest, setStockFilterData } from 'store/actionReducers/StockInvestStore';
import RowRateFilter from '../RowRateFilter'
import TableList from '../TableList'
import { ReactComponent as IconTangTruong } from '../../../../assets/images/InvestmentPortfolio/icon-tang-truong.svg'
import { ReactComponent as IconGiatri } from '../../../../assets/images/InvestmentPortfolio/icon-gia-tri.svg'
import { ReactComponent as IconDongLuong } from '../../../../assets/images/InvestmentPortfolio/icon-dong-luong.svg'
import { ReactComponent as IconDsc } from '../../../../assets/images/InvestmentPortfolio/icon-dsc.svg'

export default function StockFilter() {
    const dispatch = useDispatch();
    const LoadingStore = useSelector((state: any) => state?.LoadingStore)
    const StockInvestStore = useSelector((state: any) => state?.StockInvestStore);

    const { GetInvestCategory } = useStockInvest()
    let data: any = [...StockInvestStore?.StockFilterData || []];

    useEffect(() => {
        GetInvestCategory(StockInvestStore?.FilterStockInvest)
    }, [StockInvestStore?.FilterStockInvest])


    const handleChangeFilterParams = (value: string, type: string) => {
        dispatch(setStockFilterData([]))
        const paramsNews = { ...StockInvestStore?.FilterStockInvest }
        paramsNews[type] = value
        paramsNews.page = 0
        dispatch(setFilterStockInvest(paramsNews))
    }

    const LoadDataMore = () => {
        const paramsNews = { ...StockInvestStore?.FilterStockInvest }
        paramsNews.page = paramsNews.page + 1
        dispatch(setFilterStockInvest(paramsNews))
    }

    return (
        <>
            <div className='sorodyxfsm'>
                <div className='gwmqpmnwkm'>
                    <RowRateFilter defaultValue={StockInvestStore?.FilterStockInvest?.growthFilter} icon={<IconTangTruong />}
                        filterAction={(value: string) => handleChangeFilterParams(value, 'growthFilter')} title="Tăng trưởng" />
                </div>
                <div className='gwmqpmnwkm QGZyRUekxh'>
                    <RowRateFilter defaultValue={StockInvestStore?.FilterStockInvest?.valueFilter} icon={<IconGiatri />}
                        filterAction={(value: string) => handleChangeFilterParams(value, 'valueFilter')} title="Giá trị" />
                </div>
                <div className='gwmqpmnwkm'>
                    <RowRateFilter defaultValue={StockInvestStore?.FilterStockInvest?.momentumFilter} icon={<IconDongLuong />}
                        filterAction={(value: string) => handleChangeFilterParams(value, 'momentumFilter')} title="Động lượng" />
                </div>
                <div className='gwmqpmnwkm QGZyRUekxh'>
                    <RowRateFilter defaultValue={StockInvestStore?.FilterStockInvest?.dscRatingFilter} icon={<IconDsc />}
                        filterAction={(value: string) => handleChangeFilterParams(value, 'dscRatingFilter')} title="DSC đánh giá" />
                </div>
            </div>
            <div className='dpdhtfntlz'>
                <div className='rvtheozjaa'>
                    <Spin spinning={LoadingStore?.loading.indexOf('LoadListStockInvest') > -1}>
                        <TableList data={data} showAdd={true} LoadMoreData={() => LoadDataMore()} />
                    </Spin>
                </div>
            </div>
        </>
    )
}